<script setup lang="ts">
import { isAppUsing } from '@@/bits/flip'
import type { Section } from '@@/types'
import SurfacePostGroupHeaderSection from '@@/vuecomponents/SurfacePostGroupHeaderSection.vue'
import SurfacePostGroupHeaderSectionOld from '@@/vuecomponents/SurfacePostGroupHeaderSectionOld.vue'
defineProps<{
  section: Section
  width: number
}>()
</script>

<template>
  <SurfacePostGroupHeaderSection
    v-if="isAppUsing('groupPostsV2')"
    :section="section"
    style="transform: rotate(-2deg)"
    :hide-buttons="true"
    :style="{ width: `${width}px` }"
  />
  <SurfacePostGroupHeaderSectionOld
    v-else
    :section="section"
    style="transform: rotate(-2deg)"
    :hide-buttons="true"
    :style="{ width: `${width}px` }"
  />
</template>
